import { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { Card } from "@mui/material";
import {
  boxStyle,
  StyledTableCell,
  StyledTableRow,
  searchStyle,
  buttonPosition,
} from "../style/style";
import { getobj, postobj, dltobj, updateobj } from "../apicall/apicall";
import { headerStyle } from "../style/style";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import Pagination from "@mui/material/Pagination";
import { MenuItem } from "@mui/material";
import "react-notifications/lib/notifications.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { validateField } from "../apicall/commonFunction";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { dist } from "../apicall/constants";

export default function AdminList() {
  const [admins, setadmins] = useState();
  const [loaded, setloaded] = useState(true);
  const [addAdmin, setaddAdmin] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });
  const [totalpage, setpaget] = useState();
  const [refresh, setrefresh] = useState(false);
  const [page, setpage] = useState(1);
  const [open, setopen] = useState(false);
  const [search, setsearch] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedAction, setselectedAction] = useState("");
  const customerId = sessionStorage.getItem("admin_id");

  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "user/admin-list/?page=" +
      page +
      "&role=ADMIN&search=" +
      search;
    const res = getobj(url);
    res.then(function (res) {
      console.log("customer_id: " + customerId);
      setadmins(res.results);
      if (res.count % 5 > 0) {
        setpaget(Math.floor(res.count / 5) + 1);
      } else {
        setpaget(Math.floor(res.count / 5));
      }
      setloaded(false);
    });
  }, [refresh, page, search]);

  const handleSearch = (e) => {
    e.preventDefault();
    setloaded(true);
  };

  function reset() {
    setaddAdmin({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
    });
    setErrors({});
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setaddAdmin({
      ...addAdmin,
      [name]: value,
    });
  };

  const handlePagechange = (event, value) => {
    setloaded(true);
    setpage(value);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!addAdmin.first_name.trim()) {
      newErrors.first_name = "First Name cannot be blank";
    }

    if (!addAdmin.last_name.trim()) {
      newErrors.last_name = "Last Name cannot be blank";
    }

    if (!/^\d{1,10}$/.test(addAdmin.phone)) {
      newErrors.phone = "Please enter a 10-digit phone number";
    }
    const val = validateField(addAdmin, dist);
    if (Object.keys(val).length > 0) {
      Object.keys(val).forEach((field) => {
        console.log(field);
        newErrors[field] = val[field];
      });
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const url =
        process.env.REACT_APP_ZEWA_URL + "user/add-customer/?role=ADMIN";
      const res = postobj(url, addAdmin);
      res
        .then((response) => {
          console.log(response.status);
          if (response.status === 200) {
            return response;
          }
          throw new Error(response);
        })
        .then((response) => {
          // Do something with the response
          console.log(res);
          setopen(false);
          setErrors({});
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Successfully Added.", "Added", 2000);
          setaddAdmin("");
          setrefresh(!refresh);
        })
        .catch((error) => {
          console.log(error);
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Email already registered", "Failed", 2000);
        });
    }
  };

  const handleaction = (id, val) => {
    const url = process.env.REACT_APP_ZEWA_URL + "user/admin-list/?role=ADMIN";
    if (val === "Delete") {
      const res = dltobj(url, { id: id });
      res.then((r) => {
        if (r["Message"] === "Deleted Successfully") {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Successfully deleted.", "Deleted", 2000);
          setpage(1);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Could not delete.", "Failed", 2000);
        }
      });
    } else {
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = { id: id, active: status };
      const res = updateobj(url, data);
      res.then(function (data) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Status Updated.", "Updated", 2000);

        setrefresh(!refresh);
      });
      //console.log(data);
    }
  };

  return (
    <div>
      <Card sx={boxStyle}>
        <Card sx={headerStyle}>
          Admin List
          <form style={searchStyle} onSubmit={handleSearch}>
            <FormControl variant="standard" sx={searchStyle}>
              <InputLabel htmlFor="input-with-icon-adornment">
                Search Admin
              </InputLabel>
              <Input
                id="input-with-icon-adornment"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchSharpIcon color="primary" />
                  </InputAdornment>
                }
                value={search}
                onChange={(e) => {
                  setsearch(e.target.value);
                  if (e.target.value === "") {
                    handleSearch(e);
                  }
                }}
              />
            </FormControl>
          </form>
        </Card>
      </Card>
      <Box sx={boxStyle}>
        <Box sx={buttonPosition}>
          <Button
            sx={{ margin: "5px" }}
            variant="contained"
            color="primary"
            onClick={() => {
              setopen(true);
            }}
          >
            add admin
          </Button>
        </Box>
      </Box>
      {loaded ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <Box sx={boxStyle}>
          {admins.length > 0 ? (
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      <b>Name</b>
                    </StyledTableCell>

                    <StyledTableCell>
                      <b>Email</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Phone</b>
                    </StyledTableCell>

                    <StyledTableCell>
                      <b>Status</b>
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {admins &&
                    admins.map((user) => (
                      <StyledTableRow key={user.id}>
                        <StyledTableCell>
                          {user.first_name !== ""
                            ? user.first_name + " " + user.last_name
                            : user.email.split("@")[0]}
                        </StyledTableCell>

                        <StyledTableCell>{user.email}</StyledTableCell>
                        <StyledTableCell>
                          {user.phone !== "0" ? user.phone_number : "NA"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user.active ? "Active" : "Inactive"}
                        </StyledTableCell>

                        <StyledTableCell>
                          <Button>
                            <TextField
                              select
                              name="user_list"
                              id="deviceName"
                              sx={{ width: "clamp(80px, 12vw, 100px)" }}
                              variant="outlined"
                              label="Action"
                              value={selectedAction}
                              disabled={
                                localStorage.getItem("role") === "ADMIN" &&
                                customerId == user.id
                              }
                              onChange={(e) => {
                                if (e.target.value === "Detail") {
                                  handleaction(
                                    user.customer_id,
                                    e.target.value,
                                  );
                                } else {
                                  handleaction(user.id, e.target.value);
                                }
                                setselectedAction("");
                              }}
                            >
                              <MenuItem
                                value={user.active ? "Deactivate" : "Activate"}
                              >
                                {user.active ? "Deactivate" : "Activate"}
                              </MenuItem>
                              <MenuItem value="Delete">Delete</MenuItem>
                            </TextField>
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
                <Pagination
                  count={totalpage}
                  page={page}
                  variant="outlined"
                  color="primary"
                  onChange={handlePagechange}
                />
              </Table>
            </TableContainer>
          ) : (
            <p>No Admin Added yet</p>
          )}
        </Box>
      )}
      <NotificationContainer />
      <Dialog
        open={open}
        onClose={() => {
          setopen(false);
        }}
      >
        <DialogTitle>Add Admin</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <TextField
              error={errors.first_name || false}
              id="outlined-error-helper-text"
              sx={{ margin: "5px" }}
              variant="outlined"
              label="Enter First Name"
              name="first_name"
              type="text"
              onChange={handleChange}
              required
              helperText={errors.first_name ? errors.first_name : ""}
            />
            <TextField
              error={errors.last_name || false}
              id="outlined-error-helper-text"
              sx={{ margin: "5px" }}
              variant="outlined"
              label="Enter last Name"
              name="last_name"
              type="text"
              onChange={handleChange}
              required
              helperText={errors.last_name ? errors.last_name : ""}
            />
            <TextField
              id="outlined-basic"
              sx={{ margin: "5px" }}
              variant="outlined"
              label="Enter Email"
              name="email"
              type="email"
              onChange={handleChange}
              required
            />
            <TextField
              error={errors.phone || false}
              id="outlined-error-helper-text"
              sx={{ margin: "5px" }}
              variant="outlined"
              label="Enter Phone Number"
              name="phone"
              type="text"
              onChange={handleChange}
              required
              helperText={errors.phone ? errors.phone : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              // onClick={() => {
              //   //console.log(addAdmin);
              //   handleSubmit(addAdmin);
              // }}
            >
              add
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                reset();
                setopen(false);
              }}
            >
              cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
